import axios from '../config/axios';
import type { AddGuestCartResponse } from '../interface/interface';
import { Endpoints } from './endPoints';

const removeGuestProductFromCart = async (
  productId: string,
): Promise<AddGuestCartResponse> => {
  try {
    const guestCartId = sessionStorage.getItem('guestCartId');

    if (!guestCartId) {
      return {
        success: false,
        message: 'No cart found',
      };
    }

    const response = await axios.post(Endpoints.REMOVE_USER_CART, {
      cart_id: guestCartId,
      product_id: productId,
    });

    if (response.status === 200) {
      return {
        success: true,
        status: response.status,
      };
    }

    return {
      success: false,
      message: 'Failed to remove product from cart',
      status: response.status,
      data: response.data,
    };
  } catch (error: any) {
    console.error('Error removing product from guest cart:', error);
    return {
      success: false,
      message:
        error.response?.data?.message || 'Error removing product from cart',
      status: error.response?.status,
    };
  }
};

export default removeGuestProductFromCart;
